import { InvitedPage } from 'pages/team/invitations'
import { MembersPage } from 'pages/team/members/MembersPage'
import { StatisticsPage } from 'pages/team/statistics'
import { Navigate, type RouteObject } from 'react-router-dom'

import { Wrapper } from './Wrapper'

export const Route: RouteObject = {
	children: [
		{ element: <Navigate replace to='members' />, index: true },
		{ Component: MembersPage, path: 'members' },
		{ Component: StatisticsPage, path: 'statistics' },
		{ Component: InvitedPage, path: 'invitations' }
	],
	Component: Wrapper,
	path: '/team'
}
